import Vue from 'vue'

export const fieldEditorDialogs = Vue.observable({ items: [] })

let sequence = 0

function openDialog(type, options = {}) {
  sequence += 1
  const item = {
    key: `field-editor-${Date.now()}-${sequence}`,
    type,
    fieldId: options.fieldId ?? options.id ?? 'new',
    fieldName: options.fieldName ?? options.name ?? '',
    table: options.table ?? '',
    variant: options.variant ?? 0,
    title: options.title || (type === 'variant' ? 'Variante du champ' : 'Édition du champ'),
    width: options.width || 1400,
    persistent: Boolean(options.persistent),
    onSaved: typeof options.onSaved === 'function' ? options.onSaved : null,
    onClosed: typeof options.onClosed === 'function' ? options.onClosed : null,
  }
  fieldEditorDialogs.items.push(item)
  return item.key
}

export function openFieldEditor(options = {}) {
  return openDialog('field', options)
}

export function openFieldVariant(options = {}) {
  return openDialog('variant', options)
}

export function closeFieldEditor(key, result = null) {
  const index = fieldEditorDialogs.items.findIndex(item => item.key === key)
  if (index === -1) return
  const [item] = fieldEditorDialogs.items.splice(index, 1)
  if (item.onClosed) item.onClosed(result)
}

export function notifyFieldSaved(key, field) {
  const item = fieldEditorDialogs.items.find(dialog => dialog.key === key)
  if (item && item.onSaved) item.onSaved(field)
}

export function fieldEditorLocation(options = {}) {
  const query = {}
  if (options.name) query.name = options.name
  if (options.table) query.table = options.table
  return {
    name: 'engine-field-edit',
    params: { id: options.fieldId ?? options.id ?? 'new' },
    query,
  }
}

export function fieldVariantLocation(options = {}) {
  return {
    name: 'engine-field-variant-edit',
    params: { id: options.fieldId ?? options.id, variant: options.variant },
  }
}
